import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";

const ReservationActionsModal = ({ open, onClose, onDelete }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: "bold", color: "#d32f2f" }}>
        ⚠️ تأكيد حذف الحجز
      </DialogTitle>

      <DialogContent>
        <Typography>
          هل أنت متأكد أنك تريد حذف هذا الحجز وجميع بياناته المرتبطة؟ لا يمكن التراجع عن هذه العملية.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit" variant="outlined">
          إلغاء
        </Button>
        <Button onClick={onDelete} color="error" variant="contained">
          تأكيد الحذف
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReservationActionsModal;
